"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "latitude_deg" };
const _hoisted_3 = { class: "latitude_min" };
const _hoisted_4 = { class: "latitude_sec" };
const _hoisted_5 = { class: "latitude_deg" };
const _hoisted_6 = { class: "latitude_min" };
const _hoisted_7 = { class: "latitude_sec" };
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'BssMapLatLng',
    props: {
        latitude: {},
        longitude: {}
    },
    setup(__props) {
        var _a, _b;
        const props = __props;
        const lat_dms = (0, vue_3.computed)(() => {
            const d = Number(props.latitude);
            const deg = Math.floor(d);
            const min = Math.floor((d - deg) * 60);
            const sec = Number(((d - deg) * 60 - min) * 60).toFixed(3);
            return { deg, min, sec };
        });
        const lon_dms = (0, vue_3.computed)(() => {
            const d = Number(props.longitude);
            const deg = Math.floor(d);
            const min = Math.floor((d - deg) * 60);
            const sec = Number(((d - deg) * 60 - min) * 60).toFixed(3);
            return { deg, min, sec };
        });
        const messages = (0, vue_3.inject)('messages');
        const infobox_messages = (_b = (_a = messages.v_infobox) !== null && _a !== void 0 ? _a : messages.d_infobox) !== null && _b !== void 0 ? _b : messages.l_infobox;
        return (_ctx, _cache) => {
            return (_ctx.latitude && _ctx.longitude)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).latitude) + ": ", 1),
                    (0, vue_2.createElementVNode)("span", _hoisted_2, (0, vue_2.toDisplayString)(lat_dms.value.deg), 1),
                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).latitude_deg) + " ", 1),
                    (0, vue_2.createElementVNode)("span", _hoisted_3, (0, vue_2.toDisplayString)(lat_dms.value.min), 1),
                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).latitude_min) + " ", 1),
                    (0, vue_2.createElementVNode)("span", _hoisted_4, (0, vue_2.toDisplayString)(lat_dms.value.sec), 1),
                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).latitude_sec) + ", " + (0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).longitude) + ": ", 1),
                    (0, vue_2.createElementVNode)("span", _hoisted_5, (0, vue_2.toDisplayString)(lon_dms.value.deg), 1),
                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).longitude_deg) + " ", 1),
                    (0, vue_2.createElementVNode)("span", _hoisted_6, (0, vue_2.toDisplayString)(lon_dms.value.min), 1),
                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).longitude_min) + " ", 1),
                    (0, vue_2.createElementVNode)("span", _hoisted_7, (0, vue_2.toDisplayString)(lon_dms.value.sec), 1),
                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).longitude_sec), 1)
                ]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
